import React, { Component } from 'react';
import '../../css/style.css';
import '../Home.css';
import { Row, Col, Button, Form, Card } from 'react-bootstrap';
import { sendJson } from '../../backend/Backend';
import { translate } from "react-i18next";
import AuthenticationService from '../../backend/AuthenticationService';
import AgbCheck from "../common/AgbCheck";


class PublicEventBooking extends Component {

    constructor(props) {
        super(props);
        this.onEventInputChange = this.onEventInputChange.bind(this);
        this.saveEvent = this.saveEvent.bind(this);
        this.cancelEvent = this.cancelEvent.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleAgbCheckbox = this.handleAgbCheckbox.bind(this);


        this.state = {
            booking: {
                eventId: 'X',
                userId: '',
                fullname: '',
                telNr: '',
                email: '',
                comment: '',
                adultCount: 1,
                childCount: 0
            },
            userMinAge: '',
            userMinAgeChecked: false,
            agbChecked: false
        };
    }

    componentDidMount() {
        let oldState = this.state;
        let oldBooking = this.state.booking;


        if (AuthenticationService.isUserLoggedIn()) {
            let user = AuthenticationService.getLoggedUser();

            let newBooking = {
                ...oldBooking,
                eventId: this.props.eventId,
                userId: user.id,
                fullname: user.name,
                email: user.email
            }


            this.setState({
                ...oldState,
                booking: newBooking,
                userMinAge: this.props.userMinAge
            })
        } else {
            let newBooking = {
                ...oldBooking,
                eventId: this.props.eventId
            }
            this.setState({
                ...oldState,
                booking: newBooking,
                userMinAge: this.props.userMinAge
            })
        }

    }


    onEventInputChange(obj) {
        const { name: fieldName, value: fieldValue } = obj.target;
        let oldState = this.state;
        let oldBooking = this.state.booking;
        let newBooking = {
            ...oldBooking,
            [fieldName]: fieldValue
        }

        this.setState({
            ...oldState,
            booking: newBooking
        });

    }

    saveEvent() {
        let event = this.state.booking;

        console.log("saving event : " + JSON.stringify(event));

        sendJson('post', 'booking/create', event).then(
            received => {
                console.log("Saved Eventid: " + JSON.stringify(received));

                //if(received.ok){
                this.props.executeBooking();
                //}
            });

    }

    cancelEvent() {
        this.props.executeBooking();
    }


    handleChange(e) {
        let oldState = this.state;
        this.setState({
            ...oldState,
            userMinAgeChecked: e.target.checked
        });
    }

    handleAgbCheckbox(e) {
        let oldState = this.state;
        console.log("handleAgbCheckbox: " + this.state.agbChecked + " : " + e.target.checked);
        this.setState({
            ...oldState,
            agbChecked: e.target.checked
        });
    }


    render() {
        const { t } = this.props;
        const { fullname, telNr, email, comment, adultCount, childCount } = this.state.booking;
        //let agbChecked = this.state.agbChecked;
        return (
            <div className=" mt-1 mb-1">
                <Card border="light">
                    <Card.Header as="h3" className="text-primary"> {t("reservationTitle")}</Card.Header>
                    <Card.Body >
                        <Row >
                            <Col lg={12} md={12} className="mt-1">
                                <Form.Control value={fullname}
                                    name="fullname"
                                    onChange={this.onEventInputChange}
                                    placeholder={t("OptionalName")}
                                    id="inputFullname"
                                    maxLength={250}
                                />
                            </Col>
                        </Row>
                        <Row>

                            <Col lg={6} md={6} className="mt-1">
                                <Form.Control value={telNr}
                                    name="telNr"
                                    onChange={this.onEventInputChange}
                                    id="inputTel"
                                    placeholder={t("optTel")}
                                    maxLength={25}
                                />
                            </Col>

                            <Col lg={6} md={6} className="mt-1">
                                <Form.Control value={email}
                                    name="email"
                                    onChange={this.onEventInputChange}
                                    placeholder={t("email")}
                                    id="inputEmail"
                                    maxLength={250}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6} md={6} className="mt-1">
                                <Form inline>
                                    <Form.Group >
                                        <Form.Label htmlFor="inputadultCount">{t("adultCount")}</Form.Label>
                                        <Form.Control value={adultCount}
                                            type="number"
                                            min="1"
                                            step="1"
                                            name="adultCount"
                                            onChange={this.onEventInputChange}
                                            placeholder={t("adultCount")}
                                            id="inputadultCount"
                                            style={{ width: "80px" }}
                                            className="ml-2"
                                        />
                                    </Form.Group>
                                </Form>
                            </Col>

                            <Col lg={6} md={6} className="mt-1">
                                {this.state.userMinAge > 0 ?
                                    <Form.Check label={t("userMinAgeChecked") + this.state.userMinAge} name="userMinAgeChecked" id="userMinAgeChecked" checked={this.state.userMinAgeChecked} onChange={this.handleChange} />
                                    :
                                    <Form inline>
                                        <Form.Group >
                                            <Form.Label htmlFor="inputchildrenCount" className="ml-2 mr-2">{t("childCount")}</Form.Label>
                                            <Form.Control value={childCount}
                                                type="number"
                                                min="1"
                                                step="1"
                                                name="childCount"
                                                onChange={this.onEventInputChange}
                                                placeholder={t("childCount")}
                                                id="inputchildrenCount"
                                                style={{ width: "80px" }}
                                                className="ml-2"
                                            />
                                        </Form.Group>
                                    </Form>
                                }



                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12} md={12} className="mt-1">
                                <Form.Control value={comment}
                                    as="textarea"
                                    name="comment"
                                    placeholder={t("KommentarEingeben")}
                                    onChange={this.onEventInputChange}
                                    maxLength={250}
                                />
                            </Col>
                        </Row>
                        <Row  >
                            <Col className="mt-1" lg={12} md={12} >
                                <AgbCheck handleAgbCheckbox={this.handleAgbCheckbox} />
                            </Col>
                        </Row>

                    </Card.Body>
                    <Card.Footer >
                        <Row className="mt-1">
                            <Col lg={12} md={12} >
                                <Button onClick={this.saveEvent} className="float-right ml-2" disabled={this.validateUserMinAge() || !this.state.agbChecked} >{t("reservieren")}</Button>

                            </Col>
                        </Row>
                    </Card.Footer>
                </Card>
            </div>

        );
    }

    validateUserMinAge() {
        if (!(this.state.userMinAge > 0)) {
            return false;
        }
        return !this.state.userMinAgeChecked;
    }

}

export default translate("translations")(PublicEventBooking);